// extracted by mini-css-extract-plugin
module.exports = {"gl":"Fake3D-module--gl--2YNUd"};